import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-password-validation',
  templateUrl: './password-validation.component.html',
  styleUrls: ['./password-validation.component.css']
})
export class PasswordValidationComponent implements OnChanges {
  
  @Input() password: string;
  @Output() passwordValida = new EventEmitter<boolean>();

  public validoNumero = false;
  public validoSimbolo = false;
  public validoLongitud = false;
  public validoMayuscula = false;
  public validoMinuscula = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password']) {
      this.validarPassword(this.password);
    }
  }

  private validarPassword(pass: string): void {
    this.validoLongitud = pass.length >= 8;
    this.validoMayuscula = /[A-Z]/.test(pass);
    this.validoMinuscula = /[a-z]/.test(pass);
    this.validoNumero = /\d/.test(pass);
    this.validoSimbolo = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pass);

    const esValida = this.validoLongitud && this.validoMayuscula && this.validoMinuscula && this.validoNumero && this.validoSimbolo;
    this.passwordValida.emit(esValida);
  }
}